import {mergeService} from "../helpers/mergeService";

export const line = {
    findLineToMerge: function (id = 'bonusesRow') {
        const rowById = document.querySelector(`#${id}`);
        if (!rowById) return;

        mergeService.init(rowById, id === 'bonusesRow' ? 'bonusType' : 'packageType');
    }
};
